import { useCallback } from "react";

import * as Repository from "@/components/features/items/discount/item/ordinary/edit/model/repository";

import type * as DiscountItemOrdinaryShared from "../../../_shared";

type Props = {
	inputModel: DiscountItemOrdinaryShared.Model.ModelType.DiscountOrdinaryFormModel["InputModel"];
	onResetViewModel: () => void;
};

export const useUpdateDiscountOrdinary = ({ inputModel, onResetViewModel }: Props) => {
	const { onUpdateDiscountOrdinary: _onUpdateDiscountOrdinary } =
		Repository.Mutation.useDiscountOrdinaryUpdateMutation({ onResetViewModel });

	const onUpdateDiscountOrdinary = useCallback(
		() => _onUpdateDiscountOrdinary(inputModel),
		[_onUpdateDiscountOrdinary, inputModel],
	);

	return {
		onUpdateDiscountOrdinary,
	};
};
